module.exports = __webpack_public_path__ + "img/Alexcoutcharmtable48.da5328be.jpg";